import { SigninCallbackPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(SigninCallbackPage);
